import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import * as authService from '../services/authService';

const SignupPaymentGuard = ({ children }) => {
    const user = authService.getCurrentUser();
    const location = useLocation();

    // If not logged in, let the logical protection (if any) or guest view handle it
    // If logged in and payment is PENDING, redirect to profile
    if (user && user.payment_status === 'PENDING') {
        // Allow home, profile page and about-us pages for PENDING users
        const allowedPaths = ['/', '/profile', '/about-paper-portal', '/editorial-board'];
        if (allowedPaths.includes(location.pathname)) {
            return children;
        }
        return <Navigate to="/profile" replace />;
    }

    return children;
};

export default SignupPaymentGuard;
